import { Navigate, useLocation } from 'react-router-dom';
import { Alert, Container } from 'react-bootstrap';
import { useAuth } from '../auth';

// Redirects to /login if not authenticated; shows a plain "not authorized" message if the
// caller's role isn't in `roles` (deliberately simple - no custom error page/modal). The
// attempted path is passed as `from` so Login sends the visitor back here after they sign in.
export default function ProtectedRoute({ roles, children }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  if (roles && !roles.includes(user.role)) {
    return (
      <Container className="py-5">
        <Alert variant="warning">You don't have access to this page.</Alert>
      </Container>
    );
  }

  return children;
}
